<template>
    <article v-if="item !== null" :class="[getModuleClass(), getModuleThemeClass()]">
        <div class="text-image__content">
            <h2 v-if="item.Headline != null && item.Headline != ''" class="text-image__headline">{{ item.Headline }}</h2>
            <div v-if="item.RichText != ''" class="rich-text" v-html="item.RichText"></div>
            <template v-if="item.Link && item.Link.Link && item.Link.Link.Url">
                <link-component :link="item.Link"></link-component>
            </template>
        </div>
        <image-component v-if="item.Image.Image.Path" :image="item.Image" :keep-image-aspect-ratio="item.KeepImageAspectRatio" module-name="text-image" :sizes="getSizeParameters()" />
    </article>
</template>
<script>
import LinkComponent from '../components/link-component.vue';
import ImageComponent from '../components/image-component.vue';
import { useItem } from '../composables/item';
const { getThemeClass } = useItem();

export default {
    name: 'TextImage',
    components: {
        LinkComponent,
        ImageComponent
    },
    props: {
        item: {
            type: Object,
            default: null
        },
        modalHasNavigation: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        getModuleThemeClass() {
            return getThemeClass(this.item);
        },
        getSizeParameters() {
            return [
                {
                    breakpoint: '1920',
                    width: this.modalHasNavigation ? '568' : '743',
                    height: this.modalHasNavigation ? '585' : '765',
                    compression: 100
                },
                {
                    breakpoint: '992',
                    width: this.modalHasNavigation ? '549' : '724',
                    height: this.modalHasNavigation ? '566' : '746',
                    compression: 100
                },
                {
                    breakpoint: '480',
                    width: this.modalHasNavigation ? '595' : '855',
                    height: this.modalHasNavigation ? '613' : '880',
                    compression: 100
                },
                {
                    default: true,
                    width: '419',
                    height: '431',
                    compression: 100
                }
            ];
        },
        getModuleClass() {
            return this.item.ImageAlignment.SelectedOptions[0].Value == 'left' ? 'text-image text-image--reversed' : 'text-image';
        }
    }
};
</script>
